import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getAlternateRoute } from "@/lib/i18n/routeMap";

const LanguageSwitcher: React.FC = () => {
  const location = useLocation();
  const isSpanish = location.pathname.startsWith("/es");
  const currentLang = isSpanish ? "es" : "en";

  return (
    <div className="inline-flex items-center gap-2 rounded-full border border-metro-blue-500/30 bg-dark-800/70 px-2 py-1 text-xs font-semibold text-dark-300 shadow-sm shadow-black/20">
      <svg
        className="h-4 w-4 text-metro-blue-400"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 3a9 9 0 100 18 9 9 0 000-18zm0 0c2.5 2.6 4 6 4 9s-1.5 6.4-4 9m0-18C9.5 5.6 8 9 8 12s1.5 6.4 4 9m-7.5-9h15"
        />
      </svg>
      <div className="flex items-center rounded-full bg-dark-900/60 p-0.5">
        <Link
          to={
            currentLang === "en"
              ? location.pathname
              : getAlternateRoute(location.pathname, "en")
          }
          className={`px-2 py-1 rounded-full transition-colors ${
            currentLang === "en"
              ? "bg-metro-orange-500/20 text-metro-orange-500"
              : "text-metro-blue-400 hover:text-metro-blue-300"
          }`}
          aria-current={currentLang === "en" ? "page" : undefined}
        >
          EN
        </Link>
        <Link
          to={
            currentLang === "es"
              ? location.pathname
              : getAlternateRoute(location.pathname, "es")
          }
          className={`px-2 py-1 rounded-full transition-colors ${
            currentLang === "es"
              ? "bg-metro-orange-500/20 text-metro-orange-500"
              : "text-metro-blue-400 hover:text-metro-blue-300"
          }`}
          aria-current={currentLang === "es" ? "page" : undefined}
        >
          ES
        </Link>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
